<template>
  <!-- <div class="" style="position:fixed">
     -->
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

        <br>
        <form id="form-consumer-master-code">
              <b-row style="width:100vw">
                      <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
                          <AdminPrepaidSideNav />
                      </b-col>
                      <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
                        <b-row>
                          <b-col col cols="12" sm="12" md="12" lg="12">
                           <h1 class="heading">Consumer Master</h1>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                            <h6>Consumer Number: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3" >
                            <input id="consNo" v-model="consNo" type="text" class="validate" name="consNo" placeholder="Enter consumer number">
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <b-button pill class="h-75" variant="outline-warning" @click="searchConsNo($event)" style="padding-bottom: 10px;">Search
                            <b-icon icon="search" aria-hidden="true"></b-icon></b-button>
                          </b-col>
                        </b-row>
                        <hr/>
                        <br>
                        <div id="cosnDetails" style="display: none;">
                        <b-row>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Consumer Name: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                              <input id="consName" v-model="consName" type="text" class="validate" name="consName">
                            </b-col>

                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Address: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                            <input id="address" v-model="address" type="text" class="validate" name="address">
                            </b-col>
                        </b-row><br>
                        <b-row>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Meter No:  </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                            <input id="meterNo" v-model="meterNo" type="text" class="validate" name="meterNo" disabled></input>
                            </b-col>

                          <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                            <h6>Vendor: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3" >
                            <input id="vendor" v-model="vendor" type="text" class="validate" name="vendor">
                          </b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col col cols="6" sm="6" md="2" lg="2" offset-md="4" offset-lg="4" class="text-center">
                            <b-button variant="info" @click="updateConsumer($event)">UPDATE</b-button>
                          </b-col>
                          <b-col col cols="6" sm="6" md="2" lg="2" class="text-center">
                            <b-button variant="outline-danger">CANCEL</b-button>
                          </b-col>
                        </b-row>
                      </div>
                  </b-col>
            </b-row>
          </form>
        </b-container>
    </b-overlay>
   <br><br>
  </div>
<!-- </div> -->
</template>

<script>
import AdminPrepaidSideNav from '@/components/AdminPrepaidSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'



export default {
  name: 'Admin',
  components: {
    'AdminPrepaidSideNav' : AdminPrepaidSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data()
  {
    return{
      consNo: '',
      consName: '',
      address: '',
      meterNo: '',
      vendor: '',
      show:false
    }
  },
  methods:
  {
    searchConsNo(){
      var consNo = this.consNo;
      // alert(consNo);
      if(consNo == ""){
        this.$bvToast.toast('Consumer number can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      else{
        var parent = this;
        parent.show=true;
        axios.get(this.$urlCommon + "/dcPortal/getprepaidconsdata?consNo="+consNo).then(function(response) {
          parent.show=false;
          console.log ("response data :")
          console.log (response.data)
          var data= response.data.prepaidData;
          var msg= response.data.msg;


          if(msg == "Success"){
            document.getElementById("cosnDetails").style.display = "block";
            parent.consName = data[0][1];
            parent.address = data[0][2];
            parent.meterNo = data[0][3];
            parent.vendor = data[0][4];
          }
          else {
            parent.$bvToast.toast(msg, {
              title: `Error`,
              variant: 'danger',
              solid: true
          })
        }
        })
        .catch((e)=>{
          console.log("caught", e);
        })
      }
    },
    updateConsumer(){
      var consNo = this.consNo;
      var consName = this.consName;
      var address = this.address;
      var vendor = this.vendor;

      var dataToSend = {
        "cons_no": consNo,
        "consumer_name": consName,
        "address1": address,
        "vendor_name": vendor
      }

      console.log(dataToSend);
      var parent = this;
      parent.show=true;
      axios.post(this.$urlCommon+"/dcPortal/updateprepaidconsumermaster",dataToSend).then(function(response){
        // console.log(response.data);
        parent.show=false;
        if(response.data == "success"){
          parent.$bvToast.toast('Successfully update', {
            title: `Success`,
            variant: 'success',
            solid: true
        })
        }
        else{
          parent.$bvToast.toast('Consumer data updation failed', {
            title: `Error`,
            variant: 'danger',
            solid: true
        })
        }
      })

    }
  },
  mounted()
  {
      var userId = localStorage.getItem("userId");
      var userName = localStorage.getItem("userName");
      // {
      //   this.$router.push({ path: '/' })
      //   return;
      // }

      document.getElementById("consName").innerHTML = userName ;
      document.getElementById("consNameMb").innerHTML = userName ;

      var btn=document.getElementById("bconsMaster");
      document.querySelector(".btn-color-active").classList.remove("btn-color-active");
      btn.classList.add("btn-color-active");

  }

}


</script>

<style scoped="true">
body{
  overflow-y:hidden !important;
}
.menuCol
{
 display:block;
}
.menuItem
{
  border-radius: 50%;
  height:10rem;
  width:10rem;
  margin-top:1rem;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #6a1b9a ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
</style>
